export default __webpack_public_path__ + "static/media/PwC_Repre_Illus_Iso_05_Chatbot_RGB.f2186b4e.png";